import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map, shareReplay, tap } from 'rxjs/operators';

import { FeatureFlagsService } from '@digital-platform/shared/services';
import { User } from '@digital-platform/users/domain';
import { LoginSessionFacadeService } from '@digital-platform/users/services';

@Component({
  selector: 'digital-platform-user-profile-dropdown',
  templateUrl: './user-profile-dropdown.component.html',
  styleUrls: ['./user-profile-dropdown.component.scss'],
})
export class UserProfileDropdownComponent {
  public userName: Observable<string>;
  public showInviteUser: boolean;
  public showItAdminTools: boolean;
  public universalLogin: boolean;
  @Input() variation: string;

  constructor(
    private loginSessionFacade: LoginSessionFacadeService,
    private readonly router: Router,
    private featureFlag: FeatureFlagsService
  ) {
    this.userName = this.loginSessionFacade.loginSession$.pipe(
      map((loginSession) => {
        const {
          user: { name },
        } = loginSession;

        this.showInviteUser = this.shouldShowInviteUser(
          loginSession?.user?.permissions
        );
        this.showItAdminTools = this.shouldShowItAdminTools(
          loginSession?.user?.permissions
        );
        return name;
      }),
      shareReplay(1)
    );
    this.userName.subscribe();
    this.universalLogin = Boolean(
      this.featureFlag.getValue('isUniversalLogin')
    );
  }

  onClickLogout() {
    this.loginSessionFacade.logout('Logout successful.');
  }

  onClickInviteUser() {
    this.router.navigateByUrl('/invite-user');
  }

  onClickItAdminTools() {
    this.router.navigateByUrl('/admin-tools');
  }

  shouldShowInviteUser(permissions: User['permissions']): boolean {
    const invitePermissions = ['invite:all', 'invite:other', 'invite:org'];
    let shouldShow = false;

    invitePermissions?.forEach((permission) => {
      if (permissions?.indexOf(permission) > -1) {
        shouldShow = true;
      }
    });

    return shouldShow;
  }

  shouldShowItAdminTools(permissions: User['permissions']): boolean {
    const adminToolPermissions = [
      'add:sales_rep',
      'add:coordinator',
      'add:analyst',
    ];
    let shouldShow = false;

    adminToolPermissions?.forEach((permission) => {
      if (permissions?.indexOf(permission) > -1) {
        shouldShow = true;
      }
    });
    return shouldShow;
  }
}
